export const removeHTTPFromURL = (url: string) =>
  url.replace(/^\/\/|^.*?:(\/\/)?/, '');
